<p-button
  variant="text"
  severity="contrast"
  label="Group By"
  [disabled]="isLoading || !fields?.length"
  (onClick)="groupPopover.toggle($event)"
>
  <svg-icon src="/assets/icons/general/group.svg" />
</p-button>

<p-popover #groupPopover (onHide)="onMenuClose()" (onShow)="onMenuOpen()">
  <div class="w-80">
    <p class="p-2 pr-12! font-semibold">Select columns to group on</p>

    <div class="mb-2 ml-1 mr-3">
      <ag1-list-search
        [keys]="['displayName', 'name']"
        [items]="fields"
        placeholder="Search Columns"
        (filteredItemEvent)="filteredFields = $event"
      />
    </div>

    <div class="grid max-h-64 grid-cols-1 overflow-y-auto px-1.5">
      @for (
        field of filteredFields;
        track tableService().trackByField(index, field);
        let index = $index
      ) {
        <div class="mr-2 text-xs">
          @if (field.groupable) {
            <div class="flex items-center gap-3">
              <input
                type="text"
                [(ngModel)]="field.groupOrder"
                (change)="updateColumnGroupOrder(field, field.groupOrder)"
                pattern="^\d+$"
                class="w-8 border-transparent! p-1 hover:border-slate-300!"
              />
              <label class="flex grow select-none items-center gap-2">
                <input
                  type="checkbox"
                  [(ngModel)]="field.grouped"
                  (ngModelChange)="updateColumnGrouping(field, field.grouped)"
                />
                @if (field?.displayName) {
                  {{ field?.displayName }}
                } @else {
                  {{
                    $safeNavigationMigration(field?.name)
                      | humanize
                      | sentenceCase
                  }}
                }
              </label>
            </div>
          }
        </div>
      }
    </div>

    <div class="mt-2 flex justify-end gap-2">
      <p-button
        size="small"
        variant="text"
        severity="contrast"
        (click)="clearColumnGrouping()"
        label="Clear Grouping"
      />
      <p-button
        size="small"
        (click)="applyColumnGrouping()"
        label="Apply Grouping"
      />
    </div>

    <p-button
      variant="text"
      severity="contrast"
      size="small"
      pTooltip="Close"
      class="absolute right-1 top-2"
      (click)="closeGroupPanel()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/close.svg" />
      </ng-template>
    </p-button>
  </div>
</p-popover>
